import React from "react";
import {
  Box,
  Tab,
  Tabs,
  AppBar,
  Typography,
  Toolbar,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IWithClassName } from "../../theme/default.theme";

export enum TabEnum {
  SING_IN = "/login",
  SING_UP = "/sign-up",
  FORGOT = "/forgot-password",
}

interface AuthFrameProps extends IWithClassName {
  children: React.ReactNode;
  tab: TabEnum;
}

const AuthFrame = ({ children, tab, className }: AuthFrameProps) => {
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: TabEnum) => {
    event.preventDefault();

    navigate(newValue);
  };

  return (
    <Box className={className}>
      <AppBar className="auth-app-bar">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
          >
            <img src="/assets/images/logo.png" alt="logo" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box className="form-cont">
        <Typography variant="h4">Welcome to DataZop!</Typography>

        <Tabs value={tab} onChange={handleChange} centered>
          <Tab label="Sign In" value={TabEnum.SING_IN} />
          <Tab label="Sign up" value={TabEnum.SING_UP} />
          <Tab label="Forgot" value={TabEnum.FORGOT} />
        </Tabs>

        <Box className="auth-form">{children}</Box>
      </Box>
    </Box>
  );
};

export default AuthFrame;
